import React from 'react';
import { Grid } from '@material-ui/core';
import { useStyles, partnersLogic } from './partners.module';
import AlliesCard from '../shared/alliesCard/alliesCard';

export default function Partners() {
  const { translator } = partnersLogic();
  const classes = useStyles();
  return (
    <Grid container className={classes.root}>
      <Grid item className={classes.container} xs={12}>
        <Grid item className={classes.cardsContainer} xs={12}>
          <AlliesCard ally="aenor" />
          <AlliesCard ally="arauco" />
          <AlliesCard ally="aws" />
          <AlliesCard ally="british" />
          <AlliesCard ally="corfo" />
          <AlliesCard ally="ecota" />
          <AlliesCard ally="magical" />
          <AlliesCard ally="sme" />
          <AlliesCard ally="stellar" />
          <AlliesCard ally="techstars" />
          <AlliesCard ally="verra" />
        </Grid>
      </Grid>
    </Grid>
  );
}
